import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => {
  return {
    genericChartWidgetCard: {
      borderRadius: 4,
      boxShadow: theme.shadows[1],
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      maxHeight: '100%',
      overflow: 'hidden'
    },
    genericChartWidgetCardContent: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      minHeight: 0,
      overflow: 'hidden',
      padding: theme.spacing(2),
      '&:last-child': {
        paddingBottom: theme.spacing(2)
      }
    },
    genericChartWidgetCardHeader: {
      borderBottom: `1px solid ${theme.vars.palette.divider}`,
      minHeight: '3rem',
      padding: '0rem 1rem',
      textTransform: 'none',
      '& .MuiTypography-root': {
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '1.5rem'
      },
      '& .MuiCardHeader-action': {
        alignSelf: 'center',
        margin: 0
      }
    },
    genericChartWidgetChart: {
      flex: 1,
      height: '100%',
      overflow: 'hidden'
    },
    genericChartWidgetChartLoading: {
      height: '100%',
      position: 'relative'
    }
  };
});

export default useStyles;
